import { ArrowRight } from "lucide-react";
import PageHeader from "@/components/site/PageHeader";
import LeadDialog from "@/components/site/LeadDialog";
import { CASE_STUDIES } from "@/data/site";

export default function CaseStudies() {
  return (
    <main data-testid="case-studies-page">
      <PageHeader
        overline="Case Studies"
        title="Real systems. Measurable outcomes."
        subtitle="A selection of the platforms, products and automations we've built for operators across industries."
        testid="case-studies-page-header"
      />

      <section className="py-12 md:py-16">
        <div className="container-zx grid gap-6 md:grid-cols-2">
          {CASE_STUDIES.map((c) => (
            <article key={c.title} className="card-surface overflow-hidden" data-testid={`cs-card-${c.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
              <div className="relative aspect-[16/9] overflow-hidden bg-gradient-to-br from-[#050F1C] to-[#0F2B48]">
                <img
                  src={c.image}
                  alt={c.title}
                  loading="lazy"
                  className={
                    "absolute inset-0 h-full w-full opacity-95 " +
                    (c.fit === "contain" ? "object-contain p-5" : "object-cover")
                  }
                />
                <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-[#071A2D] via-[#071A2D]/30 to-transparent" />
                <div className="absolute top-3 left-3 chip bg-[#071A2D]/80 backdrop-blur">{c.industry}</div>
              </div>
              <div className="p-7">
                <h3 className="font-display text-xl md:text-2xl font-semibold text-white">{c.title}</h3>
                <p className="mt-3 text-sm text-ink-400">{c.summary}</p>
                <div className="mt-5 grid grid-cols-3 gap-3">
                  {c.metrics.map(([v, l]) => (
                    <div key={l} className="rounded-lg border border-white/[0.06] bg-white/[0.02] px-3 py-2">
                      <div className="text-base font-bold text-white">{v}</div>
                      <div className="text-[10px] tracking-[0.18em] uppercase text-ink-400">{l}</div>
                    </div>
                  ))}
                </div>
                <div className="mt-5 flex flex-wrap gap-2">
                  {c.tags.map((t) => <span key={t} className="chip">{t}</span>)}
                </div>
              </div>
            </article>
          ))}
        </div>
        <div className="container-zx mt-12 text-center">
          <LeadDialog
            source="case_studies_page"
            titleVariant="project"
            trigger={
              <button type="button" className="btn-primary" data-testid="cs-cta">
                Discuss a similar project <ArrowRight className="h-4 w-4" />
              </button>
            }
          />
        </div>
      </section>
    </main>
  );
}
